module.exports = __webpack_public_path__ + "media/profile_pictures/profile-picture-4-97bdda51.jpg";